import axios from 'axios';

const axiosFetch = axios.create({
  timeout: 5000,
});

export default axiosFetch;
